export default {
    name: 'ContextLocale',
    properties: {
        country: { required: true },
        language: { required: true },
    },
};
